import { Redirect } from 'expo-router';

export default function KursiPlayLegacyIndexRedirect() {
  return <Redirect href="/learn/path/create" />;
}
